export const primaryColor = '#c19ade';

export const backgroundColor = '#f2f2f2';

export const textColor = '#58585b';

export const activeTestColor = '#3eb24d';

export const completedTestColor = '#3048a8';

export const CTGColor = {
    fhr: '#F45BAC',
    fhrTwin: '#93246b',
    ua: '#54A7DC',
    mhr: '#C17876',
}

export const analysisColor = {
    pathological: '#FF878A',
    suspicious: '#F1B975',
    normal: '#98D490',
    loading: '#909090'
}

export const signalStrength = {
    red: '#FF878A',
    orange: '#F1B975',
    green: '#98D490',
}